import { default as React, FC } from 'react'
import { LocationTypes } from '../../types/location'

const TypeBadge: FC<{ locationType: string }> = ({ locationType }) => (
  <div
    className={`type-badge${locationType === LocationTypes.BIN ? ' -bin' : ''}`}
  >
    {locationType}
  </div>
)

export default TypeBadge
